<template>
  <div
    class="tooltip"
    @click.stop=""
    ref="tooltip"
  >
    <i
      class="icon icon--tooltip-icon"
      @click.stop="handleTooltip(true)"
    ></i>
    <i
      class="icon icon--status-ok"
      @click.stop="handleTooltip(true)"
    ></i>
    <i
      class="icon icon--cross-gray"
      v-if="showCross"
      @click.stop="$emit('cross-click')"
    ></i>
    <div
      id="tooltip-overlay"
      class="fixed up wrapper background-overlay highest-priority fade"
      :class="{'fade-in': show}"
      @click="handleTooltip(false)"
    ></div>
    <div
      class="fixed up priority-6 highest-priority full-width big-white-tooltip"
      :class="{'tooltip-open': show}"
    >
      <div class="wrapper f-center">
        <div class="ikcp-container-685 fit-height container-white pt-8 pb-8">
          <slot></slot>

          <div class="width-10 flex justify-content-start justify-content-center-768">
            <button
              tabindex="-1"
              class="button-add still-small width-3-768 width-7-480"
              @click.stop="handleTooltip(false)"
            >
              <span v-if="!btnCancelSlot">Zatvoriť</span>
              <span v-if="btnCancelSlot"><slot name="button-cancel"></slot></span>
            </button>
          </div>

          <i
            id="close-button-tooltip"
            class="icon icon--cross-gray hide block-768 close-button absolute"
            @click.stop="handleTooltip(false)"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Tooltip',
    props: [
      'showCross',
    ],
    data() {
      return {
        show: false,
      };
    },
    computed: {
      btnCancelSlot() { return !!this.$slots["button-cancel"]; },
    },
    methods: {
      handleTooltip(bool) {
        this.show = bool;
        this.$emit('is-open', bool);
        const { tooltip } = this.$refs;
        const method = bool ? 'add' : 'remove';
        tooltip.parentNode.classList[method]('highest-priority');
      },
    },
  };
</script>
